import { PersonaConfig } from '../types';

export const waterSportsPersona: PersonaConfig = {
  id: 'watersports',
  name: 'Water Sports',
  icon: '🏄',
  description: 'Streamflow percentiles, surface winds, gust density, and water temps.',
  accentColor: '#06b6d4',
  timeline: {
    showSolarLunarTrack: true,
    showMoonPhaseBadges: true,
  },
  forecastPanel: {
    temperaturePlotMode: 'single_location_only',
    hideAstronomicalEvents: false,
    showMilkyWayArButton: false,
  },
  mapDefaults: {
    recommendedPrimaryLayer: undefined,
    enabledOverlays: [],
  },
};
